import classNames from 'classnames';
import * as React from 'react';
import Course from './Course';
import Staff from './Staff';
import SwitchCourseStaff from './SwitchCourseStaff';

import css from './index.module.scss';
import { MerchantBookingStaffApi } from '../../../../../../interfaces/merchants/bookings/staff';
import { MerchantBookingCourse } from '../../../../../../interfaces/merchants/bookings/courses';

export enum SwitchType {
  Course = 'course',
  Staff = 'staff',
}

interface Props {
  nickname: string;
  resourceId: string;
  courses: MerchantBookingCourse[];
  staff: MerchantBookingStaffApi[];
}

const Appointment: React.FC<Props> = ({
  nickname,
  resourceId,
  courses,
  staff,
}) => {
  const classes = classNames(css.Appointment);
  const bookingPath = `/${nickname}/${resourceId}/book`;

  const [switchType, setSwitchType] = React.useState(SwitchType.Course);

  return (
    <div className={classes}>
      {staff.length > 0 && (
        <SwitchCourseStaff selected={switchType} onClick={setSwitchType} />
      )}
      <div className={css.Appointment__Content}>
        {switchType === SwitchType.Course &&
          courses.length > 0 &&
          courses.map((c) => (
            <Course
              key={c.canonical_id}
              courseName={c.name}
              image={c.image}
              price={c.price}
              duration={c.duration}
              text={c.description}
              href={`${bookingPath}?selected_course=${c.id}`}
            />
          ))}
        {switchType === SwitchType.Staff &&
          staff.length > 0 &&
          staff.map((s) => (
            <Staff
              key={s.canonical_id}
              staffName={s.name}
              image={s.image}
              description={s.description}
              href={`${bookingPath}?selected_staff=${s.id}`}
            />
          ))}
      </div>
    </div>
  );
};

export default Appointment;
